var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkOpenFloatingButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_18099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.191406,
    y: 0.35376,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_18099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19141 22.3538C5.64141 22.3538 5.17074 22.1581 4.77941 21.7668C4.38741 21.3748 4.19141 20.9038 4.19141 20.3538V4.35376C4.19141 3.80376 4.38741 3.33276 4.77941 2.94076C5.17074 2.54943 5.64141 2.35376 6.19141 2.35376H18.1914C18.7414 2.35376 19.2124 2.54943 19.6044 2.94076C19.9957 3.33276 20.1914 3.80376 20.1914 4.35376V20.3538C20.1914 20.9038 19.9957 21.3748 19.6044 21.7668C19.2124 22.1581 18.7414 22.3538 18.1914 22.3538H6.19141ZM6.19141 20.3538H18.1914V4.35376H16.1914V11.3538L13.6914 9.85376L11.1914 11.3538V4.35376H6.19141V20.3538Z",
    fill: "#228BE6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOpenFloatingButton);
export default __webpack_public_path__ + "static/media/bookmark_open_floating_button.ea4d20d0043bb18e1675e69046fd9162.svg";
export { ForwardRef as ReactComponent };